import { gql } from '@apollo/client'

export const CREATE_REVIEW = gql`
    mutation CreateProductRating ($input: CreateProductRatingInput!) {
        createProductRating(input: $input) {
            rating_functionality
            rating_documentation
            rating_support
            title
            rating_text
        }
    }
`
